import { LoyaltyServiceOfferStoreRestrictionMode } from 'generated/graphql-gateway';

import { OfferStoreRestrictionMode } from './is-store-allowed';

/**
 * Minimal-store-locator params that let the locator disable restaurants an
 * offer already excludes.
 *
 * `availableStoreIds` is omitted for ALL_STORES and for an empty id list, since
 * neither narrows the selectable restaurants and the locator treats a missing
 * list as "no restriction to apply".
 */
export function buildStoreRestrictionLocatorParams({
  storeRestrictionMode,
  availableStoreIds,
}: {
  storeRestrictionMode?: OfferStoreRestrictionMode;
  availableStoreIds?: readonly (string | null | undefined)[] | null;
}): Record<string, string> {
  if (!storeRestrictionMode) {
    return {};
  }

  const params: Record<string, string> = { storeRestrictionMode };
  const ids = (availableStoreIds ?? []).filter((id): id is string => Boolean(id));

  if (storeRestrictionMode !== LoyaltyServiceOfferStoreRestrictionMode.ALL_STORES && ids.length) {
    params.availableStoreIds = ids.join(',');
  }

  return params;
}
